import React, {useEffect, useState} from 'react';
import {useAuth} from '../../contexts/auth';
import {useLocation} from "react-router-dom";
import {findMenuText} from '../../utils/admin.utils';

const ZagolovokFromMenu = () => {
    const {navigation, selectedDog} = useAuth()
    const [menuName, setMenuName] = useState('Главная')
    const location = useLocation();

    useEffect(() => {
        setMenuName(findMenuText(navigation, location.pathname, selectedDog) ?? ' ')
    }, [navigation, location.pathname, selectedDog])


    return (
        <>
            {menuName}
        </>
    );
}

export default ZagolovokFromMenu
